import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import "./livetvmv.css";
import icoleft from "./Images/icoleft.png";

export default function LiveTVMV() {
    /*const [searchParams] = useSearchParams();

    const h = searchParams.get("h");
    const a = searchParams.get("a");
    const ch = searchParams.get("Channel");*/

    return (
        <div style={{ height: "100vh", overflow: "hidden" }}>
            <div style={{ display: "flex", marginBottom: "5px" }}>
                <div className="title"><img src={icoleft} width="15" style={{ paddingRight: "5px" }} />MultiView</div>
            </div>
            <div className="parent">
                <div className="tv_child">Click "MultiView" to create your own Multi View</div>
                <div className="tv_child">Click "MultiView" to create your own Multi View</div>
                <div className="tv_child">Click "MultiView" to create your own Multi View</div>
                <div className="tv_child">Click "MultiView" to create your own Multi View</div>
            </div>
        </div>
    );
}